import { Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useUsersTableContext } from '../../../../UsersTableContext'
import { User } from '../../../../UsersTableContext/types'

export function useEditOptions(): EditRowActionOptions<User, User> {
  const {
    editModal: { toggle },
  } = useUsersTableContext()
  return {
    permission: Permission.EditUserPermission,
    modal: { type: 'custom', toggle },
    disabled: ({ developer }) =>
      developer
        ? { message: 'Developer Permissions cannot be edited on this page' }
        : false,
  }
}
